module.exports = __webpack_public_path__ + "static/media/Pegasus.e39558ef.glb";